import { render, staticRenderFns } from "./headerComp.vue?vue&type=template&id=9c76d3c6&scoped=true&"
import script from "./headerComp.vue?vue&type=script&lang=ts&"
export * from "./headerComp.vue?vue&type=script&lang=ts&"
import style0 from "./headerComp.vue?vue&type=style&index=0&id=9c76d3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c76d3c6",
  null
  
)

export default component.exports